import React,{ useState, useEffect, useRef } from 'react';
import bgImage from './assets/bg2.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink,useLocation, NavLink as RouterNavLink } from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'swiper/swiper-bundle.css';
import './Landing.css'
import LandingPageCarousel from './LandingPageCarousel';



function Landing(){

return (
<>
  <link
    rel="stylesheet"
    media="screen"
    href="assets/vendor/boxicons/css/boxicons.min.css"
  />
  <link
    rel="stylesheet"
    media="screen"
    href="assets/vendor/swiper/swiper-bundle.min.css"
  />
  <link
    rel="stylesheet"
    media="screen"
    href="assets/vendor/lightgallery.js/dist/css/lightgallery.min.css"
  />
  {/* Main Theme Styles + Bootstrap */}
  <link rel="stylesheet" media="screen" href="assets/css/theme.min.css" />
  {/* Page loading styles */}
  <style
    dangerouslySetInnerHTML={{
      __html:
        "\n      .page-loading {\n        position: fixed;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        -webkit-transition: all .4s .2s ease-in-out;\n        transition: all .4s .2s ease-in-out;\n        background-color: #fff;\n        opacity: 0;\n        visibility: hidden;\n        z-index: 9999;\n      }\n      .dark-mode .page-loading {\n        background-color: #131022;\n      }\n      .page-loading.active {\n        opacity: 1;\n        visibility: visible;\n      }\n      .page-loading-inner {\n        position: absolute;\n        top: 50%;\n        left: 0;\n        width: 100%;\n        text-align: center;\n        -webkit-transform: translateY(-50%);\n        transform: translateY(-50%);\n        -webkit-transition: opacity .2s ease-in-out;\n        transition: opacity .2s ease-in-out;\n        opacity: 0;\n      }\n      .page-loading.active > .page-loading-inner {\n        opacity: 1;\n      }\n      .page-loading-inner > span {\n        display: block;\n        font-size: 1rem;\n        font-weight: normal;\n        color: #9397ad;\n      }\n      .dark-mode .page-loading-inner > span {\n        color: #fff;\n        opacity: .6;\n      }\n      .page-spinner {\n        display: inline-block;\n        width: 2.75rem;\n        height: 2.75rem;\n        margin-bottom: .75rem;\n        vertical-align: text-bottom;\n        border: .15em solid #b4b7c9;\n        border-right-color: transparent;\n        border-radius: 50%;\n        -webkit-animation: spinner .75s linear infinite;\n        animation: spinner .75s linear infinite;\n      }\n      .dark-mode .page-spinner {\n        border-color: rgba(255,255,255,.4);\n        border-right-color: transparent;\n      }\n      @-webkit-keyframes spinner {\n        100% {\n          -webkit-transform: rotate(360deg);\n          transform: rotate(360deg);\n        }\n      }\n      @keyframes spinner {\n        100% {\n          -webkit-transform: rotate(360deg);\n          transform: rotate(360deg);\n        }\n      }\n\n    .input-cursor {\n      display: inline-block;\n      width: 2px;\n      height: 30px;\n      background-color: black;\n      margin-left: 0px;\n      animation: blink .6s linear infinite alternate;\n    }\n        \n          @keyframes blink {\n    0% {opacity: 1;}\n    40% {opacity: 1;}\n    60% {opacity: 0;}\n    100% {opacity: 0;}\n  }\n    "
    }}
  />
  {/* Theme mode */}
  <style
    type="text/css"
    id="operaUserStyle"
    dangerouslySetInnerHTML={{ __html: "" }}
  />
  {/* Page loading scripts */}
  <style
    type="text/css"
    id="jarallax-clip-0"
    dangerouslySetInnerHTML={{
      __html:
        "#jarallax-container-0 {\n            clip: rect(0 1148px 717px 0);\n            clip: rect(0, 1148px, 717px, 0);\n            -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);\n            clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);\n        }"
    }}
  />
  {/* Body */}
  {/* Page loading spinner */}
  {/* Page wrapper for sticky footer */}
  {/* Wraps everything except footer to push footer to the bottom of the page if there is little content */}
    {/* Navbar */}
    {/* Remove "navbar-sticky" class to make navigation bar scrollable with the page */}
    <section
      className="jarallax landing-hero position-relative d-flex align-items-center min-vh-100 bg-light mb-5 py-lg-5 pt-5"
      style={{ backgroundImage: `url(${bgImage})` }}
      data-jarallax=""
      data-img-position="0% 100%"
      data-speed="0.5"
      //data-jarallax-original-styles={`background-image: url(${bgImage});`}
    >
      <div className="container position-relative zindex-5 py-5">
        <div className="row justify-content-md-start justify-content-center">
          <div className="col-md-12 col-sm-8 order-md-1 order-2 d-flex flex-column justify-content-between pt-2 pt-md-5 mt-0 mt-md-5 text-md-start text-center">
            <div className="pt-1 pt-md-5">
              {/* Text */}
              <h1 className="display-2">
                <span>Contacts at</span>{" "}
                <span className="text-gradient-primary">$0.02/record</span>
                <span className="text-primary">
                </span>
              </h1>
              <div className="typing-container"></div>
              <h2 className="mb-md-5 mb-3 pb-3" style={{ fontWeight: 200 }}>
               <LandingPageCarousel></LandingPageCarousel>
                <span className="input-cursor" />
              </h2>
            </div>
          </div>
        </div>
        <div className="row justify-content-md-start justify-content-center">
          <div className="col-md-6 col-sm-8 order-md-1 order-2 d-flex flex-column justify-content-between text-md-start text-center">
            <div className="mb-md-5 pb-xl-5 mb-4 ">
              {/* Text */}
              <div className="d-md-flex align-items-md-start">

                <span
                >
            <NavLink
                    tag={RouterNavLink}
                    to="/upload"
                    exact
                    className="btn btn-lg btn-primary flex-shrink-0 me-md-4 mb-md-0 mb-sm-4 mb-3 text-nowrap d-inline"
                    style={{ color:"white",textDecoration:"none" }}
                  >
                    Upload List
                  </NavLink>
                </span>


   
                <p className="d-lg-block d-none">
                Send us a list of home owners, and we'll give you their contact information.
                </p>

              </div>
            </div>
            {/* Scroll down btn */}
            <div className="d-inline-flex align-items-center justify-content-center justify-content-md-start position-relative">
              <a
                data-scroll=""
                data-scroll-offset={110}
                className="btn btn-video btn-icon rounded-circle shadow-sm flex-shrink-0 stretched-link me-3"
              >
                <i className="bx bx-chevron-down" />
              </a>
            </div>
          </div>
          {/* Animated gfx */}
          <div className="col-sm-6 col-sm-6 col-9 order-md-2 order-1"></div>
        </div>
      </div>
      <div
        id="jarallax-container-0"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          overflow: "hidden",
          zIndex: -100
        }}
      >
        <div
          style={{
            backgroundPosition: "0% 100%",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            position: "fixed",
            top: 0,
            left: 0,
            width: 1148,
            height: 717,
            overflow: "hidden",
            pointerEvents: "none",
            transformStyle: "preserve-3d",
            backfaceVisibility: "hidden",
            willChange: "transform, opacity",
            marginTop: 0,
            transform: "translate3d(0px, 0px, 0px)"
          }}
        />
      </div>
    </section>
    <section className='container mb-5 text-center'>

    <div id = "video" className="bg-dark border border-light rounded-3 py-5 px-4 px-sm-0">
    <h2 className="h1 text-light display-4 mb-4 text-gradient-primary">
            Get Started
            </h2>
            <div className='video-container'>
            <iframe title="Ninja Skip Tracing" src="https://drive.google.com/file/d/12k8pE1pIrEBGibyB_cg0xW-ZLNhsm09c/preview" width="640" height="480" allow="autoplay"></iframe>
    </div>
      </div>


    </section>
    <section className="container mb-5 ">
      {/* Comparison table */}
      <h2 className="h1 mb-4 text-center">Why choose Ninja</h2>
      <p
        className="mb-4 mx-auto pb-3 fs-lg text-center"
        style={{ maxWidth: 700 }}
      >
Our primary focus is to build lasting relationships with our customers. To achieve this, we've carefully crafted an undeniably powerful real estate skip tracing service that guarentees exceptional quality and value for your business.
      </p>
      <div
        className="swiper pt-3 swiper-initialized swiper-horizontal swiper-pointer-events"
        data-swiper-options='{
    "slidesPerView": 1,
    "pagination": {
      "el": ".swiper-pagination",
      "clickable": true
    },
    "breakpoints": {
      "500": {
        "slidesPerView": 2
      },
      "991": {
        "slidesPerView": 3
      }
    }
  }'
      >
<div className="features row">
    {/* Item */}
    <div className="col-12 col-lg-4 px-2 border-end-lg">
        <div className="text-center">
        <FontAwesomeIcon icon="coins" className="fa-3x m-3" style = {{color:"#A455F3"}} />

            <h4 className="mb-2 pb-1">Competitive Pricing</h4>
            <p className="mx-auto" style={{ maxWidth: 336 }}>
            Ninja Skip Tracing offers skip tracing services for as low as $0.02 per record, the best available on the market. For bulk orders, we also offer special volume discounts.
            </p>
        </div>
    </div>
    {/* Item */}
    <div className="col-12 col-lg-4 px-2 border-end-lg">
        <div className="text-center">
        <FontAwesomeIcon icon="bolt" className="fa-3x m-3" style = {{color:"#A455F3"}} />

            <h4 className="mb-2 pb-1">Fast Turnaround</h4>
            <p className="mx-auto" style={{ maxWidth: 336 }}>
            We understand the importance of time in your business. Our service is designed to deliver accurate results fast, so you can start prospecting quickly and confidently.
            </p>
        </div>
    </div>
    {/* Item */}
    <div className="col-12 col-lg-4 px-2">
        <div className="text-center">
        <FontAwesomeIcon icon="bullseye" className="fa-3x m-3" style = {{color:"#A455F3"}} />

            <h4 className="mb-2 pb-1">High Accuracy</h4>
            <p className="mx-auto" style={{ maxWidth: 336 }}>
            With Ninja Skip Tracing, accuracy is never compromised. Our proprietary system ensures that you receive reliable and accurate data every time.
            </p>
        </div>
    </div>
</div>

        {/* Pagination (bullets) */}
        <div className="swiper-pagination position-relative pt-2 pt-sm-3 mt-4 swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal swiper-pagination-lock">
          <span
            className="swiper-pagination-bullet swiper-pagination-bullet-active"
            tabIndex={0}
            role="button"
            aria-label="Go to slide 1"
            aria-current="true"
          />
        </div>
        <span
          className="swiper-notification"
          aria-live="assertive"
          aria-atomic="true"
        />
      </div>
      <h2 id="features" className="h1 mt-5 mb-4 text-center">

      Unbeatable Value
      </h2>
      <p
        className="mb-4 mx-auto pb-3 fs-lg text-center"
        style={{ maxWidth: 700 }}
      >
Ninja Skip Tracing sets the standard in skip tracing with its combination of competitive pricing, speed, and precision. Improve your business efficiency and confidence by choosing a service that delivers excellence and value, in one simple package designed to take less than 60 seconds to use.
      </p>

    </section>
    <section className="bg-secondary py-5">
      <div className="container py-2 py-md-3 py-lg-4 py-xl-5">
        <div className="row  gx-3 gx-lg-4">
          <div className="col-md-6 mb-3 mb-md-0 ">
            <div className="card bg-dark h-100 p-xl-4 pt-5">
              <div className="card-body text-center ">
                <h2 className="display-4 text-light"><del>$0.03/record</del></h2>
                <h3 className="display-4 text-light">$0.02/record</h3>
                <h2 className='display-4 text-gradient-primary'>33% off!</h2>
                <p className="lead fw-small fs-5 text-white">
                  Skip tracing on demand, no subscriptions.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3 mb-md-0">
            <div className="card bg-light h-100 p-xl-4">
              <div className="card-body text-center pt-3">
                <h2 className = "display-5">
                  Questions?
                </h2>
                <h2 className = "display-4">Contact support at</h2>
                <h2 className = "display-4 invisible"><a href="tel:+17744620442">+1 (774) 462-0442</a></h2>
                <h2 className = "display-6"><a href = "mailto:info@ninjaskiptracing.com">info@ninjaskiptracing.com</a></h2>
                <h2 className = "lead fw-small fs-5 invisible">Text us "CREDITS" plus your account email for 500 free credits!</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="getStarted" className="container mt-5">
      <div className="bg-dark border border-light rounded-3 py-5 px-4 px-sm-0">
        <div className="row justify-content-center py-sm-2 py-lg-5">
          <div className="col-xl-6 col-lg-7 col-md-8 col-sm-10 text-center">
            <h2 className="h1 text-light display-4 mb-4 text-gradient-primary">
              Ready to Get Started?
            </h2>
            <p className="fs-lg text-light opacity-70 mb-0">
            Send us a list of home owners, and we'll give you their contact information.
            </p>
  
            {/* Desktop form */}
            {/* Mobile form */}
           <div className='mt-5'>
            <NavLink
                    tag={RouterNavLink}
                    to="/upload"
                    exact
                    className="btn btn-danger my-3 mt-5 fs-3 font-weight-light d-none d-sm-inline"
                    style={{ fontWeight: 200, color:"white",textDecoration:"none" }}
                  >
              Upload your list here
                  </NavLink>
            </div>

          </div>
        </div>
      </div>
    </section>
    <section className="container">
      {/* Breadcrumb */}
      {/* Page title */}
      {/* Contact form */}
    </section>
    {/* Extra large modal*/}

  {/* Footer */}
  <footer className="bg-light p-4.5 text-center">
    <p className="ninjaLogo" />
    <p>
    © 2024 Ninja Real Estate Services LLC. All rights reserved.
    </p>
    <a href="/terms">Terms of Service</a>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <a href="/privacy">Privacy Policy</a>
  </footer>
  {/* Back to top button */}
  <iframe
    id="front-chat-iframe"
    title="Front Chat"
    style={{
      position: "fixed",
      border: "none",
      zIndex: 99999999,
      height: 86,
      width: 86,
      bottom: 4,
      right: 9
    }}
    srcDoc='<div id="front-chat-container"></div>'
  />
  {/* Vendor Scripts */}
  {/* Main Theme Script */}
</>


);

}

export default Landing;